import React, { useState, useRef, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import Carousel from "react-bootstrap/Carousel";
import ReactPlayer from "react-player";
import "../../assets/stylesheets/Utils.css";
import { useTranslation } from "react-i18next";
import { Collapse } from "react-bootstrap";
import { createUser } from "../../api/api";

async function sendPatientRegistration(mail, password, props, applicationName) {
  try {
    const accountData = {
      account: {
        email: mail,
        password: password,
      },
    };
    await createUser("/account/create", accountData);
    props.setRegistrationSuccess(true);
  } catch (error) {
    props.setRegistrationFailed(true);
  }
}

export default function NewRegistration(props) {

  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [pwRepeat, setPwRepeat] = useState("");
  const { t, i18n } = useTranslation();

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (password === pwRepeat) {
      sendPatientRegistration(mail, password, props, props.applicationName);
      props.onHide();
      event.preventDefault();
      event.stopPropagation();
    } else {
      alert("Passwords do not match");
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("user.registration")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("password.mail")}</Form.Label>
            <Form.Control
              type="email"
              placeholder="user@patient.com"
              autoFocus
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              required
              onChange={(e) => setMail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("password.at-least-characters")}</Form.Label>
            <Form.Control
              type="password"
              pattern=".{8,20}"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("password.repeat")}</Form.Label>
            <Form.Control
              type="password"
              pattern=".{8,20}"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              onChange={(e) => setPwRepeat(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("actions.send")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
